import Vue from 'vue'
import Vuex from 'vuex'
import cadencier from './cadencier'
import authentication from './authentication'
import hygiene from './hygiene'
import tracabilite from './tracabilite'
import commande from './commande'
import objectifs from './objectif'
import achats from './achats'
import backlog from './backlog'
import integration from './integration'
import remarques from './remarques'
import recettes from './recettes'
import etiquettes from './etiquettes'
import navbar from './navbar'
import chat from './chat'
import database from './database'
import keyboard from './keyboard'
import mail from './mail'
import context from './context'
import notilus from './notilus'
import checklist from './checklist'
import plateau from './plateau'

Vue.use(Vuex)
Vue.config.devtools = true

export default new Vuex.Store({
  // strict: true,
  state: {
    context: context.state,
    navbar: navbar.state,
    chat: chat.state,
    database: database.state,
    cadencier: cadencier.state,
    authentication: authentication.state,
    hygiene: hygiene.state,
    tracabilite: tracabilite.state,
    commande: commande.state,
    objectifs: objectifs.state,
    achats: achats.state,
    backlog: backlog.state,
    integration: integration.state,
    remarques: remarques.state,
    recettes: recettes.state,
    etiquettes: etiquettes.state,
    keyboard: keyboard.state,
    mail: mail.state,
    notilus: notilus.state,
    checklist: checklist.state,
    plateau: plateau.state,
  },
  mutations: {
    ...context.mutations,
    ...chat.mutations,
    ...navbar.mutations,
    ...database.mutations,
    ...cadencier.mutations,
    ...authentication.mutations,
    ...hygiene.mutations,
    ...tracabilite.mutations,
    ...commande.mutations,
    ...objectifs.mutations,
    ...achats.mutations,
    ...integration.mutations,
    ...backlog.mutations,
    ...remarques.mutations,
    ...recettes.mutations,
    ...etiquettes.mutations,
    ...keyboard.mutations,
    ...mail.mutations,
    ...notilus.mutations,
    ...checklist.mutations,
    ...plateau.mutations,
  },
  getters: {
    ...achats.getters,
    ...context.getters,
    ...checklist.getters,
    ...chat.getters,
  },
  actions: {
    ...context.actions,
    ...mail.actions,
    ...chat.actions,
    ...navbar.actions,
    ...cadencier.actions,
    ...authentication.actions,
    ...hygiene.actions,
    ...database.actions,
    ...tracabilite.actions,
    ...commande.actions,
    ...objectifs.actions,
    ...achats.actions,
    ...integration.actions,
    ...backlog.actions,
    ...remarques.actions,
    ...recettes.actions,
    ...keyboard.actions,
    ...etiquettes.actions,
    ...notilus.actions,
    ...checklist.actions,
    ...plateau.actions,
  },
})
